'use client'

import React, { useEffect } from 'react'
import dynamic from 'next/dynamic'

import type { HolidayPackagesIndexEntry } from '@/src/types/holidays'
import useClevertapForHolidays from '@/src/hooks/analytics/clevertap/holidays'
import { HOLIDAY_ACTION } from '@/src/utils/analytics/holidays/holidayEvents'

const HolidayPackagesDesktopContainer = dynamic(
    () =>
        import(
            /* webpackChunkName: "HolidayPackagesDesktopContainer" */ '@/src/containers/desktop/holidays/packages'
        ),
    { ssr: true }
)

const HolidayPackagesMobileContainer = dynamic(
    () =>
        import(/* webpackChunkName: "HolidayPackagesMobileContainer" */ '@/src/containers/mobile/holidays/packages'),
    { ssr: true }
)

interface HolidayPackagesRootLoaderProps {
    entries: HolidayPackagesIndexEntry[]
    isMobile: boolean
    domainCountry: string
}

const HolidayPackagesRootLoader: React.FC<HolidayPackagesRootLoaderProps> = ({
    entries,
    isMobile,
    domainCountry
}) => {
    const { triggerHolidayPageLoadEvent } = useClevertapForHolidays()

    // Once per load.
    useEffect(() => {
        triggerHolidayPageLoadEvent(HOLIDAY_ACTION.CATEGORY_VIEWED)
    }, [])

    return isMobile ? (
        <HolidayPackagesMobileContainer entries={entries} domainCountry={domainCountry} />
    ) : (
        <HolidayPackagesDesktopContainer entries={entries} domainCountry={domainCountry} />
    )
}

export default HolidayPackagesRootLoader
